import React from 'react';
import { getSubmitButtonOptions, TranslatableString } from '@rjsf/utils';
import Button from '../../components/Button/Button.jsx';
import IconButton from '../../components/IconButton/IconButton.jsx';
import AddIcon from '../../Icons/AddIcon.jsx';
import ArrowDown from '../../Icons/ArrowDown.jsx';
import ArrowUp from '../../Icons/ArrowUp.jsx';
import styles from '../rjsf.module.css';
import RemoveIcon from '../../Icons/RemoveIcon.jsx';

export const AddButton = ({ onClick, disabled, className, registry }) => (
  <IconButton
    type="button"
    size="small"
    title={registry.translateString(TranslatableString.AddButton)}
    icon={<AddIcon color="var(--ca-theme-palette-primary-main, #4b1c46)" />}
    disabled={disabled}
    onClick={onClick}
  />
);

export const RemoveButton = ({ onClick, disabled, style, registry }) => (
  <IconButton
    type="button"
    size="small"
    style={style}
    title={registry.translateString(TranslatableString.RemoveButton)}
    icon={<RemoveIcon />}
    disabled={disabled}
    onClick={onClick}
  />
);

export const MoveUpButton = ({ onClick, disabled, style, registry }) => (
  <IconButton
    type="button"
    size="small"
    style={style}
    title={registry.translateString(TranslatableString.MoveUpButton)}
    icon={<ArrowUp />}
    disabled={disabled}
    onClick={onClick}
  />
);

export const MoveDownButton = ({ onClick, disabled, style, registry }) => (
  <IconButton
    type="button"
    size="small"
    style={style}
    title={registry.translateString(TranslatableString.MoveDownButton)}
    icon={<ArrowDown />}
    disabled={disabled}
    onClick={onClick}
  />
);

// Rarely rendered — arrays are `copyable: false` by default and none of this app's schemas
// opt in, but every RJSF theme is expected to supply one.
export const CopyButton = ({ onClick, disabled, style, registry }) => (
  <IconButton
    type="button"
    size="small"
    style={style}
    title={registry.translateString(TranslatableString.CopyButton)}
    icon={<AddIcon />}
    disabled={disabled}
    onClick={onClick}
  />
);

// Rarely used directly — DeviceConfiguration.tsx renders its own submit <Button> as a
// child of <Form>, which replaces this entirely. Still needed for theme completeness.
export const SubmitButton = ({ uiSchema }) => {
  const { submitText, norender, props: submitButtonProps = {} } = getSubmitButtonOptions(uiSchema);
  if (norender) {
    return null;
  }
  return (
    <Button type="submit" className={styles.submitButton} {...submitButtonProps}>
      {submitText}
    </Button>
  );
};
